/**
 * Client-side file-selection validation for the availability-import upload
 * phase. Deliberately NOT shared with `packages/screens/src/media-import/` per the
 * cross-feature import ban (docs/WEB_ARCHITECTURE.md, availability-import-ui
 * spec) — a small, feature-scoped duplicate of that feature's
 * `isAcceptedSpreadsheet` shape, but with a narrower accepted set (no `.csv`)
 * matching this feature's file input `accept=".xlsx,.xls,.xlsm"`.
 *
 * Gives instant feedback when a file slips past the OS/browser picker's
 * format filter (e.g. drag-and-drop, or an explicit "All Files" selection) —
 * see CU-86cb1npz2, where a supplier's `.ods` file reached the server and
 * only then failed with an unhelpful generic error.
 */
const ACCEPTED_EXTENSIONS = ['.xlsx', '.xls', '.xlsm'];

export function isAcceptedAvailabilityFile(file: File): boolean {
  const name = file.name.toLowerCase();
  return ACCEPTED_EXTENSIONS.some((ext) => name.endsWith(ext));
}
